import React, { useEffect, useState } from "react";
import md5 from "md5";

import { makeStyles } from "@material-ui/core/styles";

import DOT from "../../components/MachineElement/DOT";
import { DOTToTikz } from "components/MachineElement/DOTToTikz";
import PersonIcon from "@material-ui/icons/Person";
import GetAppIcon from "@material-ui/icons/GetApp";
import GridOnIcon from "@material-ui/icons/GridOn";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import LockIcon from "@material-ui/icons/Lock";
import SaveIcon from "@material-ui/icons/Save";
import FileSaver from "file-saver"; ///dsfa
import validations from "../../utils/validationsMachine";
import brasilIcon from "../../assets/img/brazil (1).png";
import unitedStatesIcon from "../../assets/img/united-states (1).png";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import styles from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";

import { useDot } from "../../context/automatonContext";
import { Button, TextField } from "@material-ui/core";
import { useUser } from "../../context/userContext";
import { useAlert } from "../../context/Feedback/alertContext";
import responseArea from "../../constants/ResponseArea/responseArea";
import constants from "../../constants/navbarOptions";

import DataService from "services/DataService";
import { useRouteName } from "hooks";
import Cookie from "js-cookie";

import "./AdminNavbarStyle.css";
import { useHistory } from "react-router-dom";
import { useGrammar } from "context/grammarContext";
import { saveGrammar, saveMachine } from "../../services/saveService";

const useStyles = makeStyles(styles);

export default function AdminNavbarLinks(props) {
  const routeName = useRouteName();
  const history = useHistory();
  const classes = useStyles();
  const {
    setDot,
    createdDate,
    setDrawableDot,
    setCreatedDate,
    dotName,
    setDotName,
    currentAlgorithm,
    setActualMachine,
    setMachineStates,
    setMachineTransitions,
    machineStates,
    machineTransitions,
    drawableDot,
  } = useDot();
  const {
    originalGrammar,
    setOriginalGrammar,
    grammarName,
    grammarCreatedDate,
    setGrammarName,
    setGrammarCreatedDate,
  } = useGrammar();
  const { setAlert, activeAtentionClass } = useAlert();
  const [lastHash, setLastHash] = useState("");
  const {
    language,
    setLanguage,
    credential,
    user,
    setUser,
    setActiveUserDialog,
    setActiveChangePasswordDialog,
    isAuth,
  } = useUser();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (language == "pt") {
      let atual = document.getElementById("pt-icon");
      let antiga = document.getElementById("en-icon");
      atual.classList.add("language-select");
      antiga.classList.remove("language-select");
    } else {
      let atual = document.getElementById("en-icon");
      let antiga = document.getElementById("pt-icon");
      atual.classList.add("language-select");
      antiga.classList.remove("language-select");
    }
  }, [language]);
  useEffect(() => {
    if (routeName === "Draw") {
      setDisableFunction(false);
    } else {
      setDisableFunction(true);
    }
  }, [routeName]);
  const [isDisableFunction, setDisableFunction] = useState(false);

  const toDotLanguage = () => {
    let dott = new DOT(machineStates, machineTransitions);
    dott.toDotLanguage();
    let string = dott.toString();

    return string;
  };
  const toDotLanguageTikz = () => {
    let dott = new DOT(machineStates, machineTransitions);
    dott.toDotLanguage();
    let string = dott.toString();
    let tikzFile = DOTToTikz(string, dott);

    return tikzFile;
  };

  async function handleClickSave() {
    if (routeName === "Draw") {
      if (!correctName()) {
        return;
      }
      await saveMachine({
        dot: toDotLanguage(),
        dotName,
        createdDate,
        credential,
        user,
        setUser,
        setAlert,
        setCreatedDate,
        language,
      });
    } else if (routeName === "grammar") {
      if (!correctName()) {
        return;
      }
      await saveGrammar({
        grammar: originalGrammar,
        grammarName,
        grammarCreatedDate,
        credential,
        user,
        setUser,
        setAlert,
        setGrammarCreatedDate,
        language,
      });
    }
  }

  const clearScreen = () => {
    if (routeName == "grammar") {
      setOriginalGrammar("");
      setGrammarCreatedDate(null);
      setGrammarName(null);
    } else {
      setActualMachine([]);
      setDot("");
      setCreatedDate(null);
      setDrawableDot("");

      setMachineStates([]);
      setMachineTransitions([]);
      setDotName(null);
    }
  };

  const formatDate = (date) => {
    const pad = (num) => String(num).padStart(2, "0");

    const d = pad(date.getDate());
    const m = pad(date.getMonth() + 1);
    const y = date.getFullYear();
    const hh = pad(date.getHours());
    const mm = pad(date.getMinutes());
    const ss = pad(date.getSeconds());

    return `${d}/${m}/${y}-${hh}:${mm}:${ss}`;
  };

  const download = () => {
    let data;
    if (props.router === "Draw") {
      data = toDotLanguage();
    } else if (props.router == "grammar") {
      data = originalGrammar;
    } else {
      data = drawableDot;
    }
    let blob = new Blob([data], {
      type: "text/plain;charset=utf-8",
    });
    const date = new Date();
    const dataFormatada = formatDate(date);

    if (props.router === "Draw") {
      FileSaver.saveAs(blob, "automaton" + dataFormatada + ".dot");
    } else if (props.router == "grammar") {
      FileSaver.saveAs(blob, "grammar" + dataFormatada + ".txt");
    } else {
      FileSaver.saveAs(blob, "automaton" + dataFormatada + ".dot");
    }
  };

  const downloadTikz = () => {
    let data;
    if (props.router === "Draw") {
      data = toDotLanguageTikz();
    } else if (props.router == "grammar") {
      data = originalGrammar;
    } else {
      data = drawableDot;
    }
    let blob = new Blob([data], {
      type: "text/plain;charset=utf-8",
    });
    const date = new Date();
    const dataFormatada = formatDate(date);
    FileSaver.saveAs(blob, "automaton" + dataFormatada + ".tikz");
  };

  const autoLayout = async () => {
    try {
      const data = toDotLanguage();
      const isValid = validations.isValidMachine(data);
      if (isValid.valid) {
        const response = await DataService.getGridPositions(data, {
          headers: { Authorization: credential },
        });
        const auxGrammarName = grammarName;
        const auxMachineName = dotName;
        const auxGrammarDate = grammarCreatedDate;
        const auxMachineDate = createdDate;
        clearScreen();
        setDot(response.data);
        setCreatedDate(auxMachineDate);
        setGrammarCreatedDate(auxGrammarDate);
        setGrammarName(auxGrammarName);
        setDotName(auxMachineName);
      } else {
        alert("Insira um autômato válido");
      }
    } catch (e) {
      alert(e);
    }
  };

  const seeUserDetails = () => {
    handleCloseMenu();
    setActiveUserDialog(true);
  };
  const openChangePasswordDialog = () => {
    handleCloseMenu();
    setActiveChangePasswordDialog(true);
  };
  const textResponse = () => {
    if (props.router === "Draw") {
      return "";
    } else if (props.router === "Response automaton") {
      return `${responseArea.header.textBeforeAlgorithm[language]}:  ${
        currentAlgorithm != ""
          ? responseArea.header.algorithm[currentAlgorithm][language]
          : ""
      }`;
    }
  };
  const changeLanguage = (lang) => {
    if (routeName == "grammar response") {
      if (confirm(constants.alerts.info.changeLanguage[language])) {
        history.goBack();
        setLanguage(lang);
      }
    } else {
      setLanguage(lang);
    }
  };
  const returnUsername = () => {
    if (user.firstname && user.lastname) {
      return `${user.firstname} ${user.lastname}`;
    } else if (user.firstname) {
      return `${user.firstname}`;
    } else if (isAuth) {
      return `${user.email}`;
    } else {
      return `${constants.user.anonymous[language]}`;
    }
  };
  const getButtonTitle = (type) => {
    if (routeName == "grammar") {
      return (
        constants.buttons[type][language] +
        " " +
        constants.buttons.grammar[language]
      );
    } else {
      return (
        constants.buttons[type][language] +
        " " +
        constants.buttons.machine[language]
      );
    }
  };
  const getTextField = (type) => {
    if (routeName == "grammar") {
      return (
        constants.textField[type][language] +
        " " +
        constants.buttons.grammar[language]
      );
    } else if (routeName == "Draw") {
      return (
        constants.textField[type][language] +
        " " +
        constants.buttons.machine[language]
      );
    } else {
      return constants.textField.emptyPlaceholder[language];
    }
  };

  const getNameFieldValue = () => {
    if (routeName === "grammar") {
      return grammarName;
    } else if (routeName === "Draw") {
      return dotName;
    } else {
      return "";
    }
  };

  const handleNameChange = (event) => {
    const newValue = event.target.value;
    if (routeName === "grammar") {
      setGrammarName(newValue);
    } else if (routeName === "Draw") {
      setDotName(newValue);
    }
  };
  const exit = () => {
    if (confirm(constants.alerts.info.exitQuestion[language])) {
      Cookie.remove("userMail", { path: "/" });
      window.location.href = "/user/about";
    }
  };

  function correctName() {
    if (routeName === "Draw") {
      if (!dotName || dotName === "") {
        setAlert({
          active: true,
          text: constants.alerts.info.defaultName[language],
          color: "warning",
          severity: "info",
        });
        const dateNow = new Date();
        setDotName(formatDate(dateNow));
        return false;
      }
      if (
        nameExistsInList(user.historicalMachine, dotName, createdDate) !== -1
      ) {
        setAlert({
          active: true,
          text: constants.alerts.info.nameInUse[language],
          color: "danger",
          severity: "error",
        });

        return false;
      }
      return true;
    } else {
      if (!grammarName || grammarName === "") {
        setAlert({
          active: true,
          text: constants.alerts.info.defaultName[language],
          color: "warning",
          severity: "info",
        });
        const dateNow = new Date();
        setGrammarName(formatDate(dateNow));
        return false;
      }
      if (
        nameExistsInList(
          user.historicalGrammar,
          grammarName,
          grammarCreatedDate
        ) !== -1
      ) {
        setAlert({
          active: true,
          text: constants.alerts.info.nameInUse[language],
          color: "danger",
          severity: "error",
        });
        return false;
      }
      return true;
    }
  }

  function nameExistsInList(list, name, ignoreCreatedDate) {
    return list.findIndex(
      (item) => item.name === name && item.createdDate !== ignoreCreatedDate
    );
  }

  useEffect(() => {
    const saveIfChanged = () => {
      let currentData = "";

      if (routeName === "Draw") {
        const dot = toDotLanguage();
        const isValid = validations.isValidMachine(dot);
        if (
          !isValid.valid ||
          !dot ||
          dot.trim() === "digraph G { }" ||
          dot.trim().replace(/\s+/g, "") === "digraphG{}"
        ) {
          return;
        }
        currentData = JSON.stringify({ variables: dot, name: dotName });
      } else if (routeName === "grammar") {
        if (!originalGrammar || originalGrammar.length === 0) {
          return;
        }
        currentData = JSON.stringify({
          variables: originalGrammar,
          name: grammarName,
        });
      }

      const currentHash = md5(currentData);

      if (currentHash !== lastHash) {
        setLastHash(currentHash);
        if (routeName === "Draw") {
          if (!correctName()) {
            return;
          }
          saveMachine({
            dot: toDotLanguage(),
            dotName,
            createdDate,
            credential,
            user,
            setUser,
            setAlert,
            setCreatedDate,
            language,
            isAutoSave: true,
          });
        } else if (routeName === "grammar") {
          if (!correctName()) {
            return;
          }
          saveGrammar({
            grammar: originalGrammar,
            grammarName,
            grammarCreatedDate,
            credential,
            user,
            setUser,
            setAlert,
            setGrammarCreatedDate,
            language,
            isAutoSave: true,
          });
        }
      }
    };

    const interval = setInterval(saveIfChanged, 60000);
    return () => clearInterval(interval);
  }, [
    routeName,
    toDotLanguage,
    originalGrammar,
    dotName,
    grammarName,
    lastHash,
  ]);

  return (
    <div className={classes.manager}>
      <div className={classes.flex}></div>
      <div style={{ marginRight: "5em" }}>{textResponse()}</div>

      <div className={classes.manager}>
        <div className="container-icons-language">
          <a href="https://www.freepik.com" title="Freepik"></a>
          <img
            onClick={() => {
              changeLanguage("pt");
            }}
            id="pt-icon"
            src={brasilIcon}
            className="language-icon"
          />
          <img
            onClick={() => {
              changeLanguage("en");
            }}
            id="en-icon"
            src={unitedStatesIcon}
            className="language-icon"
          />
          <a href="https://www.flaticon.com/" title="Flaticon"></a>
        </div>
        {isAuth ? (
          <div>
            {isAuth && (routeName === "grammar" || routeName === "Draw") ? (
              <>
                <TextField
                  placeholder={getTextField("placeholder")}
                  value={getNameFieldValue() || ""}
                  className="name-field"
                  InputProps={{
                    style: {
                      width: "auto", // Define diretamente no campo de entrada
                    },
                  }}
                  onChange={handleNameChange}
                />
                <Button title={getButtonTitle("save")}>
                  <SaveIcon
                    aria-label="save"
                    round="true"
                    onClick={() => {
                      handleClickSave();
                    }}
                  />
                </Button>
              </>
            ) : null}
            <Button
              // disabled={isDisableFunction}
              title={getButtonTitle("clearScreen")}
              aria-label="edit"
              round="true"
              onClick={() => {
                clearScreen();
              }}
            >
              <img
                src={require("../../assets/svg/erase-svgrepo-com.svg").default}
              />
            </Button>
            <Button
              // disabled={isDisableFunction}
              title={getButtonTitle("download")}
              aria-label="edit"
              round="true"
              onClick={() => {
                download();
              }}
            >
              <GetAppIcon />
              <span>DOT</span>
            </Button>
            <Button
              // disabled={isDisableFunction}
              title={getButtonTitle("download")}
              aria-label="edit"
              round="true"
              onClick={() => {
                downloadTikz();
              }}
            >
              <GetAppIcon />
              <span>TikZ</span>
            </Button>
            <Button
              disabled={isDisableFunction}
              title={constants.buttons.layout[language]}
              aria-label="edit"
              round="true"
              onClick={() => {
                autoLayout();
              }}
            >
              <GridOnIcon />
            </Button>
            <Button
              id="basic-button"
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClickMenu}
            >
              <PersonIcon />
              {returnUsername()}
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={openMenu}
              onClose={handleCloseMenu}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              <MenuItem onClick={seeUserDetails}>
                <PersonIcon style={{ paddingRight: 10 }} />
                {constants.buttons.profile[language]}
              </MenuItem>
              <MenuItem onClick={openChangePasswordDialog}>
                <LockIcon style={{ paddingRight: 10 }} />
                {constants.buttons.security[language]}
              </MenuItem>
              <MenuItem onClick={exit}>
                <ExitToAppIcon style={{ paddingRight: 10 }} />
                {constants.buttons.logout[language]}
              </MenuItem>
            </Menu>
          </div>
        ) : (
          <div>
            {" "}
            {returnUsername()}
            <Button
              className={activeAtentionClass}
              aria-label="edit"
              round="true"
              href="/login"
              color="primary"
            >
              {constants.buttons.login[language]}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
